import request from '@/utils/request'
// 添加地址
export function addAddress(query) {
  return request({
    url: '/address',
    method: 'post',
    data: query
  })
}
// 修改地址
export function editAddress(query) {
  return request({
    url: '/address/edit/' + query.id,
    method: 'post',
    data: query
  })
}
// 地址列表
export function searchAddress(query) {
  return request({
    url: '/address/search',
    method: 'post',
    data: query
  })
}
